/**
 * 바이트 수를 읽기 쉬운 단위(B, KB, MB, GB, TB)로 변환
 */
export const formatFileSize = (bytes) => {
    if (bytes <= 0)
        return "0 B";
    const units = ["B", "KB", "MB", "GB", "TB"];
    const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${units[i]}`;
};
const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "webp"];
/**
 * 파일명 또는 File 객체가 이미지 파일인지 확인
 */
export const isImageFile = (fileOrName) => {
    const name = typeof fileOrName === "string" ? fileOrName : fileOrName.name;
    return IMAGE_EXTENSIONS.includes(name.split(".").pop()?.toLowerCase() ?? "");
};
/**
 * 파일명 extension 에 따라 blob MIME 타입 문자열을 반환
 * @param fileName 확장자가 포함된 파일명 (ex. "report.pdf")
 * @returns MIME 타입 (ex. "application/pdf")
 */
export const getBlobType = (fileName) => {
    const ext = fileName.split(".").pop()?.toLowerCase() || "";
    switch (ext) {
        case "pdf":
            return "application/pdf";
        case "jpg":
        case "jpeg":
            return "image/jpeg";
        case "png":
            return "image/png";
        case "gif":
            return "image/gif";
        case "webp":
            return "image/webp";
        case "txt":
            return "text/plain; charset=utf-8";
        case "json":
            return "application/json";
        case "csv":
            return "text/csv; charset=utf-8";
        case "xlsx":
            return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        case "xls":
            return "application/vnd.ms-excel";
        case "doc":
            return "application/msword";
        case "docx":
            return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        case "zip":
            return "application/zip";
        case "ppt":
            return "application/vnd.ms-powerpoint";
        case "pptx":
            return "application/vnd.openxmlformats-officedocument.presentationml.presentation";
        default:
            return "application/octet-stream";
    }
};
